export class FreeBetModel {
    constructor(source) {
        this.id = source.id;
        this.text = source.text;
    }
}
//# sourceMappingURL=FreeBetModel.js.map